import MaterialTable from "@material-table/core";
import { forwardRef } from "react";
import tableIcons from "./icons";
import generateOptions from "./generateOptions";
import generateLocalization from "./generateLocalization";
import components from "./components";
import generateActions from "./generateActions";
import { DELETE_LABEL, EDIT_LABEL } from "./constants";
import useLocale from "../../hooks/useLocale";
import { useSelector } from "react-redux";

const CustomTable = (
  {
    options,
    localization,
    onEdit,
    onDelete,
    editLabel = EDIT_LABEL,
    deleteLabel = DELETE_LABEL,
    ...props
  },
  ref
) => {
  const { t } = useLocale();
  const user = useSelector((state) => state.authReducer?.user);
  console.log(user);
  return (
    <MaterialTable
      tableLayout="fixed"
      tableRef={ref}
      icons={tableIcons}
      actions={
        user?.auth_level !== 4
          ? generateActions(onEdit, onDelete, editLabel, deleteLabel)
          : null
      }
      components={components}
      options={generateOptions(options, props.filename)}
      localization={generateLocalization(localization, t)}
      {...props}
    />
  );
};

export default forwardRef(CustomTable);
